<template>
  <div class="footer mt-4">
    <b-container class="py-4">
      <b-row>
        <b-col
          :cols="12"
          :sm="3"
          :md="3">
          <h4>Support</h4>
          <ul class="list-unstyled">
            <li>
              <router-link
                class="text-dark"
                to="/faq">
                FAQs
              </router-link>
            </li>
          </ul>
        </b-col>
        <b-col
          :cols="12"
          :sm="3"
          :md="3">
          <h4>Legal</h4>
          <ul class="list-unstyled">
            <li>
              <a
                class="text-dark"
                href="/privacy">
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                class="text-dark"
                href="/terms">
                Terms of Service
              </a>
            </li>
          </ul>
        </b-col>
        <b-col
          :cols="12"
          :sm="3"
          :md="3">
          <h4>Social</h4>
          <ul class="list-unstyled">
            <li>
              <router-link
                class="text-dark"
                to="/about">About Us
              </router-link>
            </li>
            <li>
              <a
                class="text-dark"
                href="https://www.facebook.com/p/ZoopLocal-61562748672634/">
                <font-awesome-icon
                  :icon="['fab', 'facebook']"/>
                Facebook
              </a>
            </li>
            <li>
              <a
                class="text-dark"
                href="https://instagram.com/zooplocal">
                <font-awesome-icon
                  :icon="['fab', 'instagram']"/>
                Instagram
              </a>
            </li>
          </ul>
        </b-col>
        <b-col
          :cols="12"
          :sm="3"
          :md="3">
          <h4>Get Help</h4>
          <ul class="list-unstyled">
            <li>
              <a
                class="text-dark"
                href="tel:1-866-899-9667">
                1-866-899-9667
              </a>
            </li>
            <li>
              <a
                class="text-dark"
                href="mailto:support@zooplocal.com">
                Send us an email
              </a>
            </li>
            <li>
              <a
                class="text-dark"
                href="/faq">
                View our FAQ
              </a>
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
    <copyright-bar/>
  </div>
</template>

<script>
import CopyrightBar from '@/components/navigation/CopyrightBar.vue'

export default {
  name: 'FooterNav',
  components: {
    CopyrightBar,
  },
}
</script>

<style lang="scss">
.footer {
  border-top: 1px solid #e9e9e9;
}
</style>
